module.exports = __webpack_public_path__ + "assets/img/Main material (10).5147f951.jpg";